(function () {
  function loadSwiper(callback) {
    if (window.Swiper) {
      callback();
      return;
    }

    var existing = document.querySelector('script[data-dodo-swiper]');
    if (existing) {
      existing.addEventListener('load', callback, { once: true });
      return;
    }

    if (!document.querySelector('link[data-dodo-swiper]')) {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      css.dataset.dodoSwiper = 'true';
      document.head.appendChild(css);
    }

    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.defer = true;
    script.dataset.dodoSwiper = 'true';
    script.onload = callback;
    document.head.appendChild(script);
  }

  function initGallery(root) {
    if (!root || !window.Swiper) {
      return;
    }

    var thumbsEl = root.querySelector('[data-dodo-thumbs]');
    var mainEl = root.querySelector('[data-dodo-main]');
    var nextEl = root.querySelector('[data-dodo-next]');
    var prevEl = root.querySelector('[data-dodo-prev]');

    if (!mainEl) {
      return;
    }

    if (mainEl.swiper) {
      mainEl.swiper.destroy(true, true);
    }

    var mainSwiper = new window.Swiper(mainEl, {
      spaceBetween: 10,
      slidesPerView: 1,
      speed: 450,
      allowTouchMove: true,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      }
    });

    function refreshGalleryLayout() {
      if (mainSwiper && !mainSwiper.destroyed) {
        mainSwiper.update();
        mainSwiper.updateSlides();
        mainSwiper.updateSize();
      }
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(refreshGalleryLayout);
    });

    Array.prototype.slice.call(mainEl.querySelectorAll('img')).forEach(function (image) {
      if (image.complete) {
        return;
      }

      image.addEventListener('load', refreshGalleryLayout, { once: true });
    });

    window.addEventListener('resize', refreshGalleryLayout);

    if (!thumbsEl) {
      return;
    }

    var thumbButtons = Array.prototype.slice.call(thumbsEl.querySelectorAll('[data-dodo-thumb-index]'));
    if (!thumbButtons.length) {
      return;
    }

    function setActiveThumb(index) {
      thumbButtons.forEach(function (btn, btnIndex) {
        if (btnIndex === index) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.classList.remove('is-active');
          btn.removeAttribute('aria-current');
        }
      });
    }

    setActiveThumb(mainSwiper.activeIndex || 0);

    if (thumbsEl.dataset.bound !== 'true') {
      thumbsEl.dataset.bound = 'true';
      thumbsEl.addEventListener('click', function (event) {
        var button = event.target.closest('[data-dodo-thumb-index]');
        if (!button || !thumbsEl.contains(button)) {
          return;
        }

        var index = parseInt(button.getAttribute('data-dodo-thumb-index') || '0', 10);
        if (isNaN(index) || !mainEl.swiper) {
          return;
        }

        mainEl.swiper.slideTo(index);
      });
    }

    mainSwiper.on('slideChange', function () {
      setActiveThumb(mainSwiper.activeIndex || 0);
    });
  }

  function initTestimonials(root) {
    if (!root || !window.Swiper) {
      return;
    }

    root.querySelectorAll('[data-dodo-testimonials]').forEach(function (carousel) {
      var nextEl = root.querySelector('[data-dodo-testimonials-next]');
      var prevEl = root.querySelector('[data-dodo-testimonials-prev]');
      var totalSlides = carousel.querySelectorAll('.swiper-slide').length;

      if (carousel.swiper) {
        carousel.swiper.destroy(true, true);
      }

      var enableDesktopNav = totalSlides > 3 && nextEl && prevEl;
      var shell = carousel.closest('.dodo-product-testimonials__slider-shell');
      if (shell) {
        shell.classList.toggle('has-desktop-nav', !!enableDesktopNav);
      }

      new window.Swiper(carousel, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        speed: 450,
        grabCursor: true,
        watchOverflow: true,
        navigation: enableDesktopNav
          ? {
              nextEl: nextEl,
              prevEl: prevEl
            }
          : undefined,
        breakpoints: {
          720: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24
          }
        }
      });
    });
  }

  function initQuantityControls(root) {
    if (!root) {
      return;
    }

    root.querySelectorAll('[data-dodo-qty]').forEach(function (control) {
      var input = control.querySelector('[data-dodo-quantity-input]');
      if (!input || control.dataset.bound === 'true') {
        return;
      }

      control.dataset.bound = 'true';

      control.querySelectorAll('[data-dodo-qty-change]').forEach(function (button) {
        button.addEventListener('click', function () {
          var delta = parseInt(button.getAttribute('data-dodo-qty-change') || '0', 10);
          if (!delta) {
            return;
          }

          var min = parseInt(input.getAttribute('min') || '1', 10);
          var maxAttr = input.getAttribute('max');
          var max = maxAttr ? parseInt(maxAttr, 10) : Number.MAX_SAFE_INTEGER;
          var current = parseInt(input.value || '1', 10);
          if (isNaN(current)) {
            current = min;
          }

          var next = current + delta;
          if (next < min) {
            next = min;
          }
          if (next > max) {
            next = max;
          }

          input.value = String(next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initVariantPricing(root) {
    if (!root) {
      return;
    }

    var select = root.querySelector('[data-dodo-variant-select]');
    if (!select) {
      return;
    }

    var currentPrices = Array.prototype.slice.call(root.querySelectorAll('.dodo-price-current, [data-dodo-sticky-price]'));
    var comparePrices = Array.prototype.slice.call(root.querySelectorAll('.dodo-price-compare, [data-dodo-sticky-compare]'));
    var offerLabels = Array.prototype.slice.call(root.querySelectorAll('.dodo-price-offer'));
    var submitButtons = Array.prototype.slice.call(root.querySelectorAll('[data-dodo-add-to-cart]'));

    function applyOptionState(option) {
      if (!option) {
        return;
      }

      currentPrices.forEach(function (node) {
        if (option.dataset.price) {
          node.textContent = option.dataset.price;
        }
      });

      comparePrices.forEach(function (node) {
        node.textContent = option.dataset.comparePrice || '';
        if (option.dataset.showCompare === 'true') {
          node.removeAttribute('hidden');
        } else {
          node.setAttribute('hidden', 'hidden');
        }
      });

      offerLabels.forEach(function (node) {
        node.textContent = option.dataset.discountLabel || '';
        if (option.dataset.showCompare === 'true' && option.dataset.discountLabel) {
          node.removeAttribute('hidden');
        } else {
          node.setAttribute('hidden', 'hidden');
        }
      });

      submitButtons.forEach(function (submitButton) {
        var available = option.dataset.available === 'true';
        submitButton.disabled = !available;
        var addLabel = submitButton.getAttribute('data-label-add') || 'Add to cart';
        var soldLabel = submitButton.getAttribute('data-label-sold') || 'Sold out';
        var submitButtonText = submitButton.querySelector('[data-dodo-add-to-cart-text]');
        if (submitButtonText) {
          submitButtonText.textContent = available ? addLabel : soldLabel;
        } else {
          submitButton.textContent = available ? addLabel : soldLabel;
        }
      });
    }

    applyOptionState(select.options[select.selectedIndex]);
    select.addEventListener('change', function () {
      applyOptionState(select.options[select.selectedIndex]);
    });
  }

  function mountSection(sectionRoot) {
    if (!sectionRoot) {
      return;
    }

    loadSwiper(function () {
      initGallery(sectionRoot);
      initTestimonials(sectionRoot);
    });

    initVariantPricing(sectionRoot);
    initQuantityControls(sectionRoot);
  }

  function mountAll() {
    document.querySelectorAll('.dodo-product[data-section-id], .dodo-product-testimonials[data-section-id]').forEach(function (sectionRoot) {
      mountSection(sectionRoot);
    });
    initBundleScroll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  } else {
    mountAll();
  }

  function initBundleScroll(root) {
    var wraps = (root || document).querySelectorAll('[data-dodo-bundles-wrap]');
    wraps.forEach(function (wrap) {
      var list = wrap.querySelector('[data-dodo-bundles-list]');
      var thumb = wrap.querySelector('[data-dodo-bundles-thumb]');
      var track = wrap.querySelector('[data-dodo-bundles-track]');
      if (!list || !thumb || !track) return;

      function updateThumb() {
        var scrollable = list.scrollWidth - list.clientWidth;
        if (scrollable <= 0) {
          track.style.display = 'none';
          return;
        }
        track.style.display = '';
        var ratio = list.clientWidth / list.scrollWidth;
        var thumbW = Math.max(ratio * 100, 20);
        var thumbLeft = (list.scrollLeft / scrollable) * (100 - thumbW);
        thumb.style.width = thumbW + '%';
        thumb.style.left = thumbLeft + '%';
      }

      list.addEventListener('scroll', updateThumb, { passive: true });
      window.addEventListener('resize', updateThumb, { passive: true });
      updateThumb();

      var dragging = false;
      var dragStartX, dragStartScroll;

      thumb.addEventListener('mousedown', function (e) {
        dragging = true;
        dragStartX = e.clientX;
        dragStartScroll = list.scrollLeft;
        e.preventDefault();
      });

      document.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var trackW = track.clientWidth;
        var scrollable = list.scrollWidth - list.clientWidth;
        var dx = e.clientX - dragStartX;
        list.scrollLeft = dragStartScroll + (dx / trackW) * list.scrollWidth;
      });

      document.addEventListener('mouseup', function () { dragging = false; });

      track.addEventListener('click', function (e) {
        if (e.target === thumb) return;
        var rect = track.getBoundingClientRect();
        var ratio = (e.clientX - rect.left) / rect.width;
        list.scrollLeft = ratio * (list.scrollWidth - list.clientWidth);
      });
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) {
      return;
    }

    var sectionRoot = event.target.querySelector('.dodo-product[data-section-id], .dodo-product-testimonials[data-section-id]');
    if (!sectionRoot && event.target.matches && event.target.matches('.dodo-product[data-section-id], .dodo-product-testimonials[data-section-id]')) {
      sectionRoot = event.target;
    }

    if (sectionRoot) {
      mountSection(sectionRoot);
    }
    initBundleScroll(event.target);
  });

})();
